import Vue from 'vue'
export default  {
    getIndexHeight (state) {    	
    	return state.indexHeight
    },
    getIndexTop (state) {    	
    	return state.indexTop
    },
    getJustAdmit (state) {    	
    	return state.JustAdmit
    },
    getState(state){
    	return state
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js